jQuery($ => {
    class LocationSearchHero {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._locations = this._element.find('.o-location-search-hero__locations');

        this._storageKeyPrefix = LOCAL_STORAGE.user_location.key_prefix;
        this._storageKeys      = LOCAL_STORAGE.user_location.keys;

        this._userPosition = {};
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        if (!this._element.hasClass('o-location-search-hero--demo')) {
            this.handleLocationsRequest();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Get User Position
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getUserPosition = async () => {
        const localStorage = this.checkLocalStorage();

        if (localStorage) {
            this._userPosition = {
              lat: localStorage.lat,
              lng: localStorage.lng
            };
        } else {
          this._userPosition = await this.requestBrowserLocation();
        }

        return this._userPosition;
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkLocalStorage = () => {
        const lat = localStorage.getItem(this._storageKeys.lat);
        const lng = localStorage.getItem(this._storageKeys.lng);

        if (!lat || !lng) return false;

        return {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Request Browser Location
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      requestBrowserLocation = () => {
        return new Promise((resolve) => {
          if (!navigator.geolocation) {
            resolve({});
            return;
          }

          navigator.geolocation.getCurrentPosition(
            (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              
              this._currentLat = lat;
              this._currentLng = lng;
              
              // Store in localStorage
              localStorage.setItem(this._storageKeys.lat, lat);
              localStorage.setItem(this._storageKeys.lng, lng);
              localStorage.setItem(this._storageKeys.type, 'precise');

              this.handleReverseGeocodeRequest(lat, lng);
              
              resolve({ lat, lng });
            },
            (error) => {
              console.warn('Geolocation error:', error);
              resolve({});
            }
          );
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateLocalStorage = (location) => {
        if (!location) return;

        Object.entries(location).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            Object.entries(value).forEach(([subKey, subValue]) => {
              if (subValue !== undefined && subValue !== null) {
                localStorage.setItem(`${this._storageKeyPrefix}.${key}.${subKey}`, subValue);
              }
            });
          } else {
            if (value !== undefined && value !== null) {
              localStorage.setItem(`${this._storageKeyPrefix}.${key}`, value);
            }
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Request
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsRequest = async (event) => {
        const userPosition = await this.getUserPosition();

        let data = {
          action: 'locations_near_user',
          data: {
            user_position: userPosition,
            class: 'o-location-search-hero__locations',
            args: {
              posts_per_page: 3,
            },
            callback: 'get_location_cards'
          }
        }

        $.ajax({
          url: AJAX.url,
          type: 'POST',
          data,
          success: this.handleLocationsRequestResponse
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Request Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsRequestResponse = (response) => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};
        const location  = data.location || {};

        if (location && location.lat && location.lng) {
          this.updateLocalStorage({
            lat: location.lat,
            lng: location.lng,
            city: {
              short: location.city?.short_name,
              long : location.city?.long_name
            },
            state: {
              short: location.state?.short_name,
              long : location.state?.long_name
            },
            zip: location.zip,
            country: {
              short: location.country?.short_name,
              long : location.country?.long_name
            },
            type: location.type
          });
        }

        if (isSuccess) {
          this.handleLocationsRequestSuccess(data);
        } else {
          this.handleLocationsRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Request Success
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsRequestSuccess = (data) => {
        this._locations.replaceWith(data.data);
        this._locations = this._element.find('.o-location-search-hero__locations');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Request Error
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsRequestError = (data) => {
        console.error('Status: Nearby locations ajax request failed', data);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reverse Geocode Request
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReverseGeocodeRequest = (lat, lng) => {
        let data = {
          action: 'reverse_geocode_latlng',
          data: {
            lat,
            lng
          }
        }

        $.ajax({
          url: AJAX.url,
          type: 'POST',
          data,
          success: this.handleReverseGeocodeRequestResponse,
          error: (xhr, status, error) => {
            console.error('AJAX request failed:', { xhr, status, error });
            this.handleReverseGeocodeRequestError({ message: 'AJAX request failed' });
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reverse Geocode Request Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReverseGeocodeRequestResponse = (response) => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};

        if (isSuccess) {
          this.handleReverseGeocodeRequestSuccess(data);
        } else {
          this.handleReverseGeocodeRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reverse Geocode Request Success
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReverseGeocodeRequestSuccess = (data) => {
        this.updateLocalStorage({
          lat: data.lat,
          lng: data.lng,
          city: {
            short: data.city?.short_name,
            long : data.city?.long_name
          },
          state: {
            short: data.state?.short_name,
            long : data.state?.long_name
          },
          zip: data.zip,
          country: {
            short: data.country?.short_name,
            long : data.country?.long_name
          },
          type: 'precise'
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reverse Geocode Request Error
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReverseGeocodeRequestError = (data) => {
        console.error('Status: Reverse geocode ajax request failed', data);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.location_search_hero = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].location_search_hero = new LocationSearchHero(_[i], opt);
        else
          ret = _[i].location_search_hero[opt].apply(_[i].location_search_hero, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-location-search-hero').location_search_hero();
});